import { SettingsScreen } from "./settings.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { FeatureTogglesScreen } from "../feature-toggles";

export const SettingsRoutes: RouteDefinition[] = [
	{
		path: Paths.settings.path,
		element: <SettingsScreen />,
		requiredPermissions: "onlyOwnerOfRoot",
	},
	{
		path: Paths.settings.featureToggles.path,
		element: <FeatureTogglesScreen />,
		requiredPermissions: "onlyOwnerOfRoot",
	},
];
